import React, {Component} from "react";
import { Radio,Tabs,Layout } from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import YwxblcxTab from "../ywxblcx/ywxblcxTab"
import css from './index.css';
import NHTree from "./YwxblcxTree";
const TabPane = Tabs.TabPane;
const baseUrlPath = "/tjcx/ywxblcx"; //基础路径
const { Content } = Layout;

/**
 * 环节办理查询
 * @author lhj
 * @date 2020-09-20
 * Version: 1.0
 */
export default class Ywxblcx extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data:[],
            defaultActiveKey:undefined,
            frameVisibleMap: {
                tableFlag: true,
            },
            LcData:[],
            radioValue:''
        }
    }

    componentWillMount() {
        this.getLcData();
    }
    //查询所有的流程
    getLcData =() => {
        NHFetch(baseUrlPath + '/getLcData', 'GET').then(res => {
            if (res) {
                console.log(res.data)
                this.setState({
                    LcData: res.data,
                    radioValue:res.data[0].VALUE
                })
                this.getData(this.state.radioValue);
            }
        })
    }



    //1.查询所选流程的所有流程环节id和环节名称
    getData = (value) => {
        const lcid = value;
        NHFetch(baseUrlPath + '/getHjData' , 'GET',"lcid="+lcid)
        .then(res => {
            if (res) {
                this.setState({ data: res.data });
                if (res.data && res.data.length > 0) {
                    this.setState({ defaultActiveKey: res.data[0].LCHJID });
                }
            }
        })
    }
    //2.遍历数据
    loop = (data) => {
        return data.map((item) => {
            let lchjid = item.LCHJID;
            // return <TabPane tab={item.lcmc} key={lcdyid}></TabPane>;
            return <TabPane tab={item.HJMC} key={lchjid}><YwxblcxTab  selectKey={lchjid}/></TabPane>;

        });
    }

    //树checkbox选中回调函数
    checkedTreeNode = (selectKeys, e) => {
        this.getData(selectKeys);
        this.refs.nhTable.filterTableData();
    }

    onChangeLc = (e) => {
        this.setState({
            radioValue: e.target.value,
        },()=>{
            console.log(this.state.radioValue)
            this.getData(this.state.radioValue);
            // this.refs.nhTable.filterTableData();
        });

    };

    render() {
        const LcData = this.state.LcData;
        // console.log('this.refs',this.refs)
        return(
            <Layout style={{ height: '100%', flexDirection: 'row' }}>
                <Radio.Group onChange={this.onChangeLc} value={this.state.radioValue}>
                    <div style={{background: 'rgb(255, 255, 255)',height: '100%', flex: '0 0 220px', width: '220px', padding: '30px 0px 20px 30px'}}>
                    {LcData.map(i => (
                    <Radio style={{height: '30px',lineHeight: '30px',display: 'block'}} value={i.VALUE} >
                        {i.LABLE}
                    </Radio>
                    ))}
                    </div>
                </Radio.Group>
                {/*<NHTree ref='nhTree' sign={"zhxg_lczz"} checkedTreeNode={this.checkedTreeNode} multiple = {false}/>*/}
                <Layout style={{ overflow: 'hidden' }}>
                    <Content >
                        <div style={{ margin: '12px', marginBottom: '0px', padding: '16px', background: '#fff', height: getSize().windowH - 123, overflow: 'hidden' }}>
                            <Tabs defaultActiveKey={this.state.defaultActiveKey}>
                                {this.loop(this.state.data)}
                            </Tabs>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/ywxblcx/index.js